module.exports = __webpack_public_path__ + "media/images/icon_x-4b8e158201e6bc71d8cb0c24c9e63c33.png";